
export default {
  name: 'TutorialComparisonSection',

  props: {
    data: {
      type: Object,
      default: () => ({
        title: '[dummy Comparison Title]',
      }),
    },
    contentAnchorData: {}
  },

  data() {
    return {
      // title: this.data?.Title || this.data?.title,
      // columns: this.data?.ComparisonTableColumn || {},
      // contentAnchorData: this.contentAnchorData,
    }
  },
}
